import { render } from "./editMarket.vue?vue&type=template&id=bdf24be6&scoped=true"
import script from "./editMarket.vue?vue&type=script&lang=js"
export * from "./editMarket.vue?vue&type=script&lang=js"

import "./editMarket.vue?vue&type=style&index=0&id=bdf24be6&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf24be6"]])

export default __exports__